import { useMutation, useQueryClient } from '@tanstack/react-query';

type CreateAdminUserParams = {
  name: string;
  email: string;
  password: string;
  passwordConfirmation: string;
  role: string;
};

export default function useCreateAdminUser() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: CreateAdminUserParams) => {
      const response = await fetch('/admin/api/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify({
          admin_user: {
            name: params.name,
            email: params.email,
            password: params.password,
            password_confirmation: params.passwordConfirmation,
            role: params.role,
          },
        }),
      });
      if (!response.ok) {
        const body = await response.json().catch(() => null);
        const message =
          body?.errors?.length > 0 ? body.errors.join(', ') : 'ユーザーの作成に失敗しました';
        throw new Error(message);
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
    },
  });
}
